module.exports = __webpack_public_path__ + "static/media/1.93feaf8f.jpg";